import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { CanDeactivate } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { BsModalService } from 'ngx-bootstrap';
import { PopupConfirmationComponent } from '../../request/popup-confirmation/popup-confirmation.component';
import { TranslateService } from '@ngx-translate/core';


export interface CanComponentDeactivate {
  checkChanges: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: "root"
})
export class CanDeactivateGuard
  implements CanDeactivate<CanComponentDeactivate> {
    constructor(private modalService: BsModalService, private translateService:TranslateService) {}

  canDeactivate(
    component: CanComponentDeactivate,
  ) {
var isThereChanges =  component.checkChanges ?component.checkChanges(): false;
if (isThereChanges) {
  const subject = new Subject<boolean>();
  let confirmationMassage = ''; let yesBtnName = 'Yes';  let noBtnName: "No";
  this.translateService.get("Common-container.Alert.ConfirmationMassage").subscribe(value => {
    confirmationMassage = value;
  });
  this.translateService.get("Common-container.Alert.YesBtnName").subscribe(value => {
    yesBtnName = value;
  });
  this.translateService.get("Common-container.Alert.NoBtnName").subscribe(value => {
    noBtnName = value;
  });

  const initialState = {
    confirmationMassage: confirmationMassage,
    yesBtnName: yesBtnName,
    noBtnName: noBtnName,
    isRoutingSource : true
  };
  const alertModalRef = this.modalService.show(
    PopupConfirmationComponent,
    { initialState, class: 'modal-dialog-centered' }
  );

  alertModalRef.content.subject = subject;
  return subject.asObservable();

} else {
  return true;
}
  }
}
